import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

export interface ConfirmOptions {
  title: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  // danger: roter Bestätigen-Knopf (Löschen, endgültige Aktionen).
  danger?: boolean;
}

export interface DialogApi {
  confirm(o: ConfirmOptions): Promise<boolean>;
  alert(o: { title: string; message?: ReactNode; confirmLabel?: string }): Promise<void>;
  prompt(o: { title: string; message?: ReactNode; label: string; initial?: string; confirmLabel?: string; required?: boolean }): Promise<string | null>;
}

export const DialogContext = createContext<DialogApi | null>(null);

// useDialog: gestaltete Dialoge statt window.confirm/alert/prompt.
export function useDialog(): DialogApi {
  const api = useContext(DialogContext);
  if (!api) throw new Error('useDialog außerhalb des DialogProvider');
  return api;
}
